import { ConfigProvider, theme } from "antd";
import type { ReactNode } from "react";

const cmsTheme = {
  algorithm: theme.darkAlgorithm,
  token: {
    colorPrimary: "#00f0ff",
    colorInfo: "#00f0ff",
    colorSuccess: "#00d1c7",
    colorWarning: "#ffc108",
    colorError: "#ff3b3b",
    colorBgBase: "#050a1f",
    colorBgContainer: "rgba(11, 30, 58, 0.72)",
    colorBgElevated: "rgba(5, 10, 31, 0.96)",
    colorBorder: "rgba(0, 240, 255, 0.2)",
    colorBorderSecondary: "rgba(0, 240, 255, 0.12)",
    colorText: "#ffffff",
    colorTextSecondary: "#a0aec0",
    colorTextTertiary: "rgba(255, 255, 255, 0.45)",
    borderRadius: 8,
    fontFamily: "'Outfit', sans-serif",
    controlHeight: 38,
  },
  components: {
    Table: {
      colorBgContainer: "transparent",
      headerBg: "rgba(5, 10, 31, 0.75)",
      headerColor: "#8fa3b8",
      headerSplitColor: "rgba(0, 240, 255, 0.12)",
      rowHoverBg: "rgba(0, 240, 255, 0.06)",
      borderColor: "rgba(0, 240, 255, 0.14)",
      headerBorderRadius: 0,
      cellPaddingBlock: 14,
      cellPaddingInline: 16,
    },
    Button: {
      borderRadius: 8,
      controlHeight: 38,
      primaryShadow: "0 4px 14px rgba(0, 240, 255, 0.25)",
      defaultBg: "rgba(11, 30, 58, 0.5)",
      defaultBorderColor: "rgba(0, 240, 255, 0.28)",
      defaultColor: "#00f0ff",
      defaultHoverBg: "rgba(0, 240, 255, 0.1)",
      defaultHoverBorderColor: "rgba(0, 240, 255, 0.4)",
      defaultHoverColor: "#00f0ff",
    },
    Input: {
      colorBgContainer: "rgba(5, 10, 31, 0.55)",
      activeBorderColor: "#00f0ff",
      hoverBorderColor: "rgba(0, 240, 255, 0.45)",
    },
    Select: {
      colorBgContainer: "rgba(5, 10, 31, 0.55)",
      selectorBg: "rgba(5, 10, 31, 0.55)",
      colorBorder: "rgba(0, 240, 255, 0.2)",
      hoverBorderColor: "rgba(0, 240, 255, 0.45)",
      activeBorderColor: "#00f0ff",
      colorText: "#ffffff",
      colorTextPlaceholder: "rgba(255, 255, 255, 0.45)",
      colorBgElevated: "rgba(5, 10, 31, 0.96)",
      optionSelectedBg: "rgba(0, 240, 255, 0.12)",
      optionActiveBg: "rgba(0, 240, 255, 0.1)",
      borderRadius: 8,
      controlHeight: 38,
    },
    Switch: {
      colorPrimary: "#00f0ff",
      colorPrimaryHover: "#33d7f9",
      handleBg: "#050a1f",
      colorTextQuaternary: "rgba(255, 255, 255, 0.88)",
      colorTextTertiary: "rgba(255, 255, 255, 0.88)",
    },
    Modal: {
      contentBg: "rgba(5, 10, 31, 0.96)",
      headerBg: "transparent",
      titleColor: "#ffffff",
    },
    Pagination: {
      itemBg: "rgba(5, 10, 31, 0.55)",
      itemActiveBg: "rgba(0, 240, 255, 0.15)",
      itemActiveColor: "#00f0ff",
      itemLinkBg: "rgba(5, 10, 31, 0.55)",
      colorText: "#a0aec0",
      colorPrimary: "#00f0ff",
      colorPrimaryHover: "#33d7f9",
    },
  },
};

export default function CmsThemeProvider({ children }: { children: ReactNode }) {
  return <ConfigProvider theme={cmsTheme}>{children}</ConfigProvider>;
}
